import {Button, Classes, Dialog, DialogProps} from '@blueprintjs/core';
import {ReactElement, ReactNode} from 'react';

export enum ControlState {
	Normal,
	Disabled,
	Loading,
}

export interface ConfirmDialogProps extends DialogProps {
	onConfirm: () => void,
	controlState?: ControlState,
	children?: ReactNode,
}

export default function ConfirmDialog({
	children,
	onConfirm,
	controlState = ControlState.Normal,
	title = 'Confirm',
	...dialogProps
}: ConfirmDialogProps): ReactElement {
	return (
		<Dialog title={title} {...dialogProps}>
			<div className={Classes.DIALOG_BODY}>
				{children}
			</div>

			<div className={Classes.DIALOG_FOOTER}>
				<div className={Classes.DIALOG_FOOTER_ACTIONS}>
					<Button
						text="Cancel"
						onClick={dialogProps.onClose}
						disabled={controlState === ControlState.Loading}
					/>

					<Button
						text="Confirm"
						onClick={onConfirm}
						intent="warning"
						disabled={controlState === ControlState.Disabled}
						loading={controlState === ControlState.Loading}
					/>
				</div>
			</div>
		</Dialog>
	);
}
